import React from "react";
import errorImage from "../../assets/images/404.jpeg";
export default () => {
  return (
    <div className="flex h-screen">
      <div className="m-auto">
        <div className="text-3xl text-center p-2 text-error">
          Page not found
        </div>
        <img src={errorImage} />
      </div>
    </div>
  );
};
